import ApiClient from './ApiClient';

class AppointmentProvidersAPI extends ApiClient {
  constructor() {
    super('appointment_providers', { accountScoped: true });
  }
}

export default new AppointmentProvidersAPI();
